import script from "./MagicLinkSent.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicLinkSent.vue?vue&type=script&setup=true&lang=js"

import "./MagicLinkSent.vue?vue&type=style&index=0&id=09a00f29&lang=scss"

const __exports__ = script;

export default __exports__